<template>
  <div>
    <div >
      <div id="style-2" class="second-bar" v-if="countStatusModuleList">
        <SingleStatus
          :filterForm="filterForm"
          :content="{name: 'Tất cả', noContact: totalContactModule}"
          color="#739A77"
          @click="clickFilterModule('all')"
         >
        </SingleStatus>
        <div v-for="option in countStatusModuleList" :key="option.id">
          <SingleStatus
            :filterForm="filterForm"
            :content="option"
            :color="option.color"
            @click="clickFilterModule(option)"
          >
          </SingleStatus>
        </div>

      </div>
    </div>
    <div class="course-extension-table">
      <CourseExtensionTable
        :filterForm="filterForm"
        @show-modal-quick-view="showQuickView"
      />
    </div>
    <modal-quick-view
      v-if="isOpenQuickView"
      :isShow="isOpenQuickView"
      :contact="selectedContact"
      :contactId="selectedContactId"
      :id="selectedItemId"
      :filter-form.sync="filterForm"
      :dataContact="dataContact"
      :contactStatusList="contactStatusList"
      :users="usersContactAdvise"
      :contactQuickviewDetail="contactQuickviewDetail"
      :routine-student-id="selectedRoutineStudentId"
      :selectedStudent="selectedStudent"
      :homeroomTeacherName="homeroomTeacherName"
      :homeroomTeacher="homeroomTeacher"
      :teachers="teachers.data"
      :levels="levels"
      :taskType="2"
      @closeModalQuickView="closeModalQuickView()"
    />
  </div>
</template>
<script>
import { TUTOR_TAB_INDEX } from '@/modules/student_care/constant/constant';
import { mapActions, mapState } from 'vuex';
import CourseExtensionTable from '@/modules/student_care/components/course_extension/CourseExtensionTable.vue';
import SingleStatus from '@/components/common/CountStatusUIv2/SingleStatus.vue';
import { LEVELS } from '@/modules/student_care/store/mutation-types';
import ModalQuickView from './ModalQuickView.vue';

export default {
  name: 'CourseExtension',
  components: {
    ModalQuickView,
    CourseExtensionTable,
    SingleStatus,
  },
  props: {
    filterForm: {
      type: Object,
      default: () => {
      },
    },
    studentForm: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      isOpenQuickView: false,
      isLoading: false,
      selected: [],
      dataContact: {},
      contactStatusList: [],
      usersContactAdvise: [],
      contactQuickviewDetail: null,
      selectedContact: null,
      selectedContactId: 0,
      selectedCustomerId: 0,
      selectedRoutineStudentId: 0,
      selectedStudent: null,
      homeroomTeacher: {},
      selectedItemId: 0,
      homeroomTeacherName: '',
      teachers: {},
      levels: LEVELS,
      isActive: 'all',
      TUTOR_TAB_INDEX,
    };
  },
  async mounted() {
    Bus.$on('closeDialog', () => {
      this.closeModalQuickView();
    });
    this.isLoading = true;
    if (!this.courseExtensionShowField) {
      await this.getCourseExtensionShowField();
    }
    this.teachers = await this.getTeacherList();
    setTimeout(() => {
      this.isLoading = false;
    }, 1000);
  },
  beforeDestroy() {
    Bus.$off('closeDialog');
  },
  methods: {
    ...mapActions('student_care', ['getCourseExtensionShowField', 'getListStudentClass', 'getTeacherList', 'getDataPeriodicallyCareTable', 'getListCallStatusCount']),
    showQuickView(item) {
      this.selectedContact = item;
      this.isOpenQuickView = true;
      this.selectedContactId = item.contact_id;
      this.selectedCustomerId = item.lms_core_user_id;
      this.selectedRoutineStudentId = item.id;
      this.selectedStudent = item;
      this.homeroomTeacher = { id: item.homeroom_teacher_id, name: item.homeroom_teacher_name };
      this.selectedItemId = item.id;
    },
    closeModalQuickView() {
      this.isOpenQuickView = false;
      this.selectedContactId = 0;
    },
    async clickFilterModule(item) {
      if (!item.id && !item.typeId && item !== 'all') return;
      // this.filterForm.contactAgency = item.code === 'SĐL' ? true : null;
      if (item === 'all') {
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        this.filterForm.callTypes = [];
        this.filterForm.callStatuses = [];
        await this.getDataPeriodicallyCareTable(this.filterForm);
        await this.getListCallStatusCount(this.filterForm);
        this.isActive = 'all';
      } else {
        this.filterForm.page = 1;
        this.filterForm.pendingPage = 1;
        this.filterForm.callTypes = [item.typeId];
        this.filterForm.callStatuses = item.id ? [item.id] : [];
        await this.getDataPeriodicallyCareTable(this.filterForm);
        this.isActive = item.id;
      }
    },
  },
  computed: {
    ...mapState('student_care', ['courseExtensionShowField', 'countStatusModuleList', 'totalContactModule']),
    ...mapState('contact_status', ['listStatus']),
    getTableHeaders() {
      if (!this.courseExtensionShowField) {
        return this.headers;
      }
      return this.headers.filter((field) => !this.courseExtensionShowField[field.value]);
    },
  },
};
</script>

<style scoped lang="scss">
.second-bar {
  margin-top: 15px;
  min-height: 39px;
  width:100%;
  overflow: auto;
  border-radius: 0px;
  background: #FFFFFF;
  display: flex;
  justify-content: flex-start;
}

.quick-filter-action {
  max-height: 35px;
  border-radius: 0px;
  font-weight: 400;
  font-size: 16px;
  line-height: 16px;
  padding: 10px;
  margin-right: 1px;
  cursor: pointer;
}
.course-extension-table{
  margin-top: 15px;
}
.active {
  font-weight: bold!important;
  font-size: 16px!important;
}
.status-count-number{
  border: #d2d2d2 0.1px solid;
  text-align: center !important;
  font-style: normal;
  font-weight: 400 ;
  font-size: 16px;
  line-height: 16px;
  color: #333333 !important;
  padding: 5px;
}
</style>
